import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { space05, space2, colorBgBase, space1, space4, space10, colorBgOpacity } = theme();

  return StyleSheet.create({
    animatedDot: {
      alignSelf: "center",
      position: "absolute",
      top: "50%",
      zIndex: 1,
    },
    itemWrapper: {
      alignItems: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      position: "relative",
    },
    paddingContainer1: {
      padding: space1,
    },
    paddingContainer2: {
      padding: space2,
    },
    paddingContainer3: {
      padding: space4,
    },
    paddingContainer4: {
      padding: space2,
    },
    paddingContainer5: {
      padding: space2,
    },
    paddingDefault: {
      padding: space1,
    },
    tooltipText: {
      color: colorBgBase,
      paddingBottom: space05,
    },
    tooltipWrapper: {
      backgroundColor: colorBgOpacity,
      borderRadius: space10,
      bottom: 0,
      left: 0,
      paddingBottom: space05,
      paddingHorizontal: space2,
      paddingTop: 6,
      position: "absolute",
      zIndex: 30,
    },
    wrapper: {
      alignContent: "center",
      alignItems: "center",
      display: "flex",
      flexWrap: "wrap",
      height: 481,
      justifyContent: "center",
    },
  });
};

export { style };
